import { createContext } from 'react';

export const checkboxPotentialFieldPathsContext = createContext<string[]>([]);
